'use client';
import ResetPassword from '@components/Auth/ResetPassword';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';

const ResetPasswordView = () => {
  const { push } = useCurrentUrl();

  return (
    <div className="tw-p-6 sm:tw-px-16 sm:tw-pt-14 sm:tw-pb-8 tw-max-w-2xl tw-mx-auto">
      <h4 className="tra-text-web-heading-4 tw-w-full tw-mb-6 sm:tw-mb-8">Reset Password</h4>
      <ResetPassword onSuccess={() => push('/account')} />
    </div>
  );
};

export default ResetPasswordView;
